import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { SearchPanel } from './SearchPanel'

export default withRouter(connect()(SearchPanel))
